import React from "react";
import { Select, ConfigProvider } from "antd";
import SC from "./style";
import InnoIcons from "@InnoIcons/";
import { Tooltip } from "@InnoUI/";
const { Option } = Select;

const SmartFolderColumnDropdownWithEditDelete = (props) => {
  const {
    defaultValue,
    placeholder,
    options,
    onChange,
    onAddNew,
    optionFilterProp = "children",
    width = "340px",
    height = "29px",
    newItemLabel = "+ Add New",
    disabled = false,
    theme = { colors: { bordertask: "#ccc" } },
    dropdowType = "",
    disabledDropdown = false,
    handleRemove = () => {},
    handleEdit = () => {},
  } = props;

  // Ensure the selected value is valid, otherwise reset it to null

  return (
    <ConfigProvider
              theme={{
          token: {
            colorPrimary: "#E36E00", // Updated to new theme color
            colorBorder: theme.colors.bordertask, // Dynamic border color
            colorText: "#374151", // Better text color
            colorTextPlaceholder: "rgba(55, 65, 81, 0.6)", // Better placeholder color
            borderRadius: 8, // Modern border radius
            controlHeight: 40, // Consistent height
          },
        }}
    >
      {SC.Globalstyles}
      <Select
        labelInValue
        popupClassName="smart-folder-column-dropdown"
        showSearch
        value={options.find((opt) => opt.id === defaultValue) || null} // Ensure only the label is shown
        disabled={disabledDropdown}
        onChange={(value) => onChange(value.value)} // Extract only the ID
        getPopupContainer={() => document.body}
        virtual={false}
        listHeight={256}
        dropdownStyle={{
          maxHeight: "320px",
          overflowY: "auto",
          padding: "0 0 8px",
        }}
        className="custom-select smart-folder-column-select"
        style={{
          width: width,
          height: height,
          textAlign: "left",
          cursor: "pointer",
        }}
        placeholder={placeholder}
        required
        optionFilterProp={optionFilterProp}
        // filterOption={(input, option) => {
        //   const childrenText = React.Children.toArray(option?.children || [])
        //     .map((child) => child)
        //     .join("");
        //   return childrenText.toLowerCase().includes(input.toLowerCase());
        // }}
        filterOption={(input, option) =>
          option?.label?.toLowerCase().includes(input.toLowerCase())
        }
        dropdownRender={(menu) => (
          <>
            {newItemLabel && !disabled && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <span
                  onClick={onAddNew}
                  style={{
                    width: "100%",
                    cursor: "pointer",
                    padding: "8px 12px",
                    color: "#E36E00",
                    fontWeight: "500",
                    transition: "all 0.2s ease",
                    borderRadius: "4px",
                    margin: "4px 8px",
                  }}
                >
                  {newItemLabel}
                </span>
              </div>
            )}
            {menu}
          </>
        )}
      >
        {options &&
          options.length > 0 &&
          options.map((option) => (
            <Option
              key={`${option.id}-${dropdowType}`}
              value={option.id}
              label={option.label}
              style={{
                borderTop: `1px solid ${theme.colors.bordertask}`,
                borderRadius: "0px",
                cursor: "pointer",
              }}
              // title={option.label}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>{option.label}</span>
                <div style={{ display: "flex", gap: "5px" }}>
                  <InnoIcons.EditIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEdit(option);
                    }}
                    sx={{
                      cursor: "pointer",
                      color: "#1565C0",
                      fontSize: "18px",
                    }}
                  />
                  {option.systemColumn ? (
                    <Tooltip
                      title={"System Column"}
                      placement="top-start"
                      arrow
                      PopperProps={{ sx: { zIndex: 1500 } }}
                    >
                      <InnoIcons.GppMaybeIcon
                        sx={{ color: "#EB7608", fontSize: "18px" }}
                      />
                    </Tooltip>
                  ) : (
                    <InnoIcons.DeleteIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemove(option.id);
                      }}
                      sx={{
                        cursor: "pointer",
                        color: "#F44336",
                        fontSize: "18px",
                      }}
                    />
                  )}
                </div>
              </div>
            </Option>
          ))}
      </Select>
    </ConfigProvider>
  );
};

export default SmartFolderColumnDropdownWithEditDelete;
